<template>
  <div id="B">
    <div id="app">
      <div :class="classShow">
        <!-- 默认导航 -->
        <div class="NavCenter">
          <div class="left">
            <router-link class="smallBanner" to="/index" tag="li">
              <img :src="HFList.logo" alt="" />
            </router-link>
          </div>
          <div class="right">
            <ul>
              <router-link
                @mouseover.native="item.modular === modularShow && item.str ? onmouseover(index) : ''"
                @mouseout="onmouseout"
                tag="li"
                :to="{
                  path:
                    '/' + item.modular === modularShow && item.str
                      ? 'productList'
                      : item.modular === modularShow && item.str
                      ? 'productList'
                      : item.path,
                  query: { id: item.id, modular: item.modular }
                }"
                v-for="(item, index) in NavList"
                :key="item.columname"
                @click="item.path === 'news' ? '' : NavTo(item.id)"
                ><span>{{ item.columname }}</span></router-link
              >
            </ul>
          </div>
        </div>
      </div>
      <!-- 滑动之后导航 -->
      <div class="Nav1">
        <div class="Nav1Center">
          <div class="left">
            <router-link class="smallBanner" to="/index" tag="li">
              <img :src="HFList.logo" alt="" />
            </router-link>
          </div>
          <div class="right">
            <ul>
              <router-link
                @mouseover.native="item.modular === modularShow ? '' : onmouseover"
                @mouseout="onmouseout"
                :class="{ active: index === curId }"
                @click="GaoLiang(item.id)"
                tag="li"
                :to="{
                  path:
                    '/' + item.modular === modularShow && item.str
                      ? 'productList'
                      : item.modular === modularShow && item.str
                      ? 'productList'
                      : item.path,
                  query: { id: item.id, modular: item.modular }
                }"
                v-for="(item, index) in NavList"
                :key="item.columname"
                ><span>{{ item.columname }}</span></router-link
              >
            </ul>
          </div>
        </div>
      </div>
      <!-- 移动端导航 -->
      <div class="phone-nav">
        <div class="phone-left">
          <router-link class="phone-logo" to="/index" tag="li">
            <img :src="HFList.logo" alt="" />
          </router-link>
        </div>
        <div class="phone-right" @click="drawer = true">
          <img src="./assets/navbtn.png" />
          <el-drawer title="" :visible.sync="drawer" :direction="direction" size="70%" :before-close="handleClose" ref="navDrawer">
            <ul class="phone-nav-link">
              <li
                @mouseover="item.modular === modularShow ? '' : onmouseover"
                @mouseout="onmouseout"
                :class="{ active: index === curId }"
                @click="goPage(item)"
                v-for="(item, index) in NavList"
                :key="item.columname"
              >
                <span>{{ item.columname }}</span>
              </li>
            </ul>
          </el-drawer>
        </div>
      </div>
      <!-- 产品下拉 -->
      <div :class="xuanfu" @mouseover="onmouseover1" @mouseout="onmouseout1" data-wow-duration=".5s">
        <div class="selectCenter">
          <div class="select" v-for="(item, index) in ModularThree" :key="item.id">
            <router-link
              :to="{
                path: '/productList',
                query: { id: arr[0].id, modular: item.modular, index: index }
              }"
            >
              <img @click="To(index)" :src="item.images !== null ? item.images : './assets/微信截图_20220317090625.png'" alt="" />

              <p>{{ item.name }}</p>
            </router-link>
          </div>
        </div>
      </div>
      <router-view :key="$route.fullPath"></router-view>
      <div class="bottom1">
        <div class="bottomCenter">
          <div class="left">
            <div class="img wow animated fadeInUp">
              <img :src="HFList.logo_footer" alt="" />
            </div>
            <div class="ul">
              <ul class="ul1 wow animated fadeInUp">
                <li class="LiBig">
                  {{ FooterList[0].columname }}
                </li>
                <li v-for="item in FooterList[0].str" :key="item.name">
                  <router-link
                    tag="a"
                    :to="{
                      path: 'productList',
                      query: { id: FooterList[0].id }
                    }"
                    >{{ item.name }}</router-link
                  >
                </li>
              </ul>
              <ul class="ul2 wow animated fadeInUp">
                <li class="LiBig">{{ FooterList[1].columname }}</li>
                <li v-for="item in FooterList[1].str" :key="item.name">
                  <router-link
                    tag="a"
                    :to="{
                      path: 'news',
                      query: { id: FooterList[1].id }
                    }"
                    >{{ item.name }}</router-link
                  >
                </li>
              </ul>
              <ul class="ul2 wow animated fadeInUp">
                <li class="LiBig">{{ FooterList[2].columname }}</li>
                <li v-for="item in FooterList[2].str" :key="item.name">
                  <router-link
                    tag="a"
                    :to="{
                      path: 'img',
                      query: { id: FooterList[2].id }
                    }"
                    >{{ item.name }}</router-link
                  >
                </li>
              </ul>
              <ul class="ul4 wow animated fadeInUp">
                <li class="LiBig">联系我们</li>
                <li>联系电话:{{ HFList.fax }}</li>
                <li>邮箱:{{ HFList.email }}</li>
                <li>地址:{{ HFList.address }}</li>
              </ul>
            </div>
          </div>
          <div class="right">
            <div class="Rt">
              <div class="Rt1 wow animated fadeInUp">
                <img :src="HFList.qrcode" alt="" />
                <p>官网公众号</p>
              </div>
              <div class="Rt2 wow animated fadeInUp">
                <img :src="Friend_Link[0].logo" alt="" />
                <p>{{ Friend_Link[0].title }}</p>
              </div>
            </div>
            <!-- 需要修改 -->
            <div class="Rb wow animated fadeInUp">
              <a :href="item.website" target="_blank" v-for="item in Friend_Link1" :key="item.id"><img :src="item.logo" alt="" /></a>
            </div>
          </div>
        </div>
        <div class="bottomB">
          <a href="https://beian.miit.gov.cn/">{{ HFList.copyright }}</a> |
          <a href="https://www.muzhige.com.cn/#/index">技术支持:拇指哥站群</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import "element-ui/lib/theme-chalk/index.css";
import { getHeards, GetHF, getFooter, GetFriend_Link } from "./https/http";
// import axios from 'axios'
// import qs from 'qs'
export default {
  data() {
    return {
      drawer: false,
      direction: "rtl",
      flag: true,
      show: false,
      classShow: "Nav",
      xuanfu: "xuanfu wow animated slideInLeft",
      Nav: "",
      id: "",
      address: "",
      content: "",
      copyright: "",
      data: "",
      num: 1,
      HFList: {},
      NavList: "",
      curId: 0,
      FooterList: "",
      Friend_Link: "",
      Friend_Link1: "",
      ModularThree: "",
      XuanfuShow: "",
      modularShow: "8",

      column: "",
      columname: "",
      arr: [],
      ProductList: "",

      Indexnum: 0
    };
  },
  beforeCreate() {
    // console.log('获取code')
  },

  created() {
    getFooter({ type: "1" }).then((res) => {
      // this.column = res.result.data;
      res.result.data.forEach((item) => {
        if (item.modular === "8") {
          this.column = item;
          this.arr.push(item);
        }
      });
    });
    getHeards({ type: 1, column_id: 236 }).then((res) => {
      this.NavList = res.result.data;
      this.NavList.forEach((item) => {
        if (item.modular === this.modularShow && item.str) {
          this.ModularThree = item.str;
        }
      });
    });
    GetHF().then((res) => {
      this.HFList = res.result;
      document.title = this.HFList.title || "";
      document.querySelector('meta[name="keywords"]').setAttribute("content", this.HFList.keyword);
      document.querySelector('meta[name="description"]').setAttribute("content", this.HFList.keyword_info);
    });
    getFooter({ type: 2 }).then((res) => {
      this.FooterList = res.result.data;
      console.log("this.Footer", this.FooterList);
    });
    GetFriend_Link({ number: 1, type: 1 }).then((res) => {
      if (res.result.length > 2) {
        this.Friend_Link = res.result.splice(0, 3);
      } else {
        this.Friend_Link = res.result.splice(0, 2);
      }
      console.log(" this.Friend_Link", this.Friend_Link);
    });
    GetFriend_Link({ number: 4, type: 2 }).then((res) => {
      if (res.result.length > 2) {
        this.Friend_Link1 = res.result.splice(0, 3);
      } else {
        this.Friend_Link1 = res.result.splice(0, 2);
      }
      console.log(" this.Friend_Link", this.Friend_Link);
    });
  },
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
    this.$parent.color = `#000`;
    this.$parent.backgroundColor = "#fff";
    let wow = new WOW({
      boxClass: "wow", //需要执行动画的元素的 class
      animateClass: "animated", //animation.css 动画的 class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备上执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  },
  methods: {
    goPage(item) {
      console.log(item);
      this.drawer = false;
      this.$refs.navDrawer.closeDrawer();
      console.log(this.drawer, "luyou");
      this.$router.push({
        path:
          "/" + item.modular === this.modularShow && item.str
            ? "productList"
            : item.modular === this.modularShow && item.str
            ? "productList"
            : item.path,
        query: { id: item.id, modular: item.modular }
      });
    },

    handleClose(done) {
      setTimeout(() => {
        done();
      }, 30);
    },
    NavTo(Id) {
      this.$EventBus.$emit("NewsId", Id);
    },
    To(x) {
      this.$EventBus.$emit("eventBusName", x);
      console.log(x);
    },
    toggle(x) {
      this.isActive = x;
    },

    onmouseover() {
      document.querySelector(".xuanfu").style.display = "block";
      this.classShow = "Nav SHOW";
    },
    onmouseout() {
      if (this.show) {
        setTimeout(function () {
          document.querySelector(".xuanfu").style.display = "none";
          this.show = false;
        }, 2000);
        this.classShow = "Nav SHOW";
      }
    },
    onmouseover1() {
      document.querySelector(".xuanfu").style.display = "block";
      this.classShow = "Nav SHOW";
    },
    onmouseout1() {
      document.querySelector(".xuanfu").style.display = "none";
      this.classShow = "Nav";
    },
    windowScroll() {
      let scrollTop = document.documentElement.scrollTop;
      if (scrollTop < 200) {
        document.querySelector(".Nav").position = "block";
      } else {
        document.querySelector(".Nav").position = "none";
      }
      if (scrollTop > 350) {
        this.flag = false;
        document.querySelector(".Nav1").style.backgroundColor = "white";
        document.querySelector(".Nav1").style.top = 0;
      } else {
        this.flag = true;
        document.querySelector(".Nav1").style.top = -90 + "px";
      }
      if (scrollTop > 0) {
        document.querySelector(".xuanfu").style.display = "none";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.windowScroll);
  }
};
</script>

<style lang="scss" scoped>
#B {
  height: 100%;
}
@media screen and (min-width: 1020px) {
  .phone-nav {
    display: none;
  }
  .Hr {
    width: 1920px;
    height: 348px;
    margin: 0 auto;
    background: #ffffff;
    border: 1px solid #e6e6e6;
  }
  li {
    list-style: none;
  }
  .xuanfu {
    width: 100%;
    height: 250px;
    min-width: 1427px;
    height: 250px;
    // display: none;
    height: 200px;
    position: fixed;
    top: 90px;
    left: 0;
    z-index: 110000;
    background: white;
    transition-duration: 1ms;
    .selectCenter {
      padding-top: 25px;
      width: 85%;
      min-width: 1427px;
      height: 85%;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      .select {
        height: 250px;
        display: flex;
        flex-direction: column;
        a {
          text-align: center;
          color: #666666;
          display: flex;
          flex-direction: column;
          // display: inline-block;
          width: 96px;
          // height: 96px;
          overflow: hidden;
          .img {
            display: flex;
            margin: 0 auto;
            max-width: 100%;
            // max-height:100%;
          }
          p {
            font-size: 16px;
            float: left;
            color: #666666;
            margin-left: 30px;
            text-align: center;
            margin: 0 auto;
          }
        }

        a:hover {
          p {
            color: #ff8229;
          }
        }
        // .img {
        //   width: 65px;
        //   height: 65px;
        //   display: flex;
        //   margin: 0 auto;
        //   p {
        //     font-size: 16px;
        //     float: left;
        //     color: #666666;
        //     margin-left: 30px;
        //     text-align: center;
        //     margin: 0 auto;
        //   }
        // }
      }
    }
  }
  * {
    margin: 0;
    padding: 0;
  }
  a {
    text-decoration: none;
  }

  #B {
    width: 100%;
    min-width: 1427px;
    height: 100%;
    #app {
      width: 100%;
      min-width: 1427px;
      height: 937px;
      .Nav {
        width: 100%;
        height: 90px;
        position: absolute;
        top: 0px;
        left: 0;
        z-index: 11000;
        .NavCenter {
          width: 1427px;
          margin-top: 13px;

          min-width: 1427px;
          height: 77px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 auto;
          .left {
            width: 232px;
            height: 66px;
            .smallBanner {
              width: 400px;
              height: 66px;
              background-repeat: no-repeat;
              position: absolute;
              background-size: 100%;
              cursor: pointer;
              display: flex;
              align-items: center;
              img {
                max-width: 100%;
                max-height: 100%;
              }
            }
          }
          .right {
            width: 840px;
            height: 67px;
            float: right;
            ul {
              width: 840px;
              height: 67px;
              list-style: none;
              display: flex;
              font-size: 14px;
              line-height: 67px;
              text-align: center;
              margin-right: 282px;

              > li {
                width: 140px;
                height: 67px;
                color: black;
                font-size: 14px;
                line-height: 67px;
                text-align: center;
              }
              li:hover {
                border-radius: 2px;
                border-bottom: 4px solid #ffffff;
                cursor: pointer;
              }
              li:hover {
                color: white;
                width: 140px;
                height: 67px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 67px;
                text-align: center;
              }
              span {
                width: 56px;
                height: 14px;
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                line-height: 30px;
              }
            }
          }
        }
      }
      .Nav[class*="SHOW"] {
        width: 100%;
        height: 90px;
        position: absolute;
        top: 0px;
        left: 0;
        z-index: 11000;
        background: white;
        .NavCenter {
          width: 1427px;
          min-width: 1427px;
          height: 77px;
          margin-top: 13px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 auto;
          .right {
            width: 840px;
            height: 67px;
            float: right;
            ul {
              margin-top: 8px;

              width: 840px;
              height: 67px;
              list-style: none;
              display: flex;
              font-size: 14px;
              line-height: 67px;
              text-align: center;
              margin-right: 282px;
              > li {
                width: 140px;
                height: 50px;
                color: black;
                font-size: 14px;
                line-height: 50px;
                text-align: center;
                span {
                  width: 27px;
                  height: 14px;
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #333333;
                  line-height: 30px;
                }
              }
              li:hover {
                width: 140px;
                height: 50px;
                background: #ff8229;
                border-radius: 25px;
                cursor: pointer;
                span {
                  color: white;
                }
              }
            }
          }
        }
      }
      .Nav1 {
        width: 100%;
        position: absolute;
        top: 0px;
        left: 0;
        z-index: 11000;
        transition: top 0.3s linear;
        min-width: 1427px;
        height: 77px;
        /* display: none; */
        position: fixed;
        top: -90px;
        left: 0;
        padding-top: 13px;
        margin-bottom: 11px;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px #e6e6e6;
        .Nav1Center {
          width: 1427px;
          height: 77px;
          margin: 0 auto;
          .left {
            .smallBanner {
              width: 400px;
              height: 66px;
              background-repeat: no-repeat;
              position: absolute;
              background-size: 100%;
              cursor: pointer;
              display: flex;
              align-items: center;
              img {
                max-width: 100%;
                max-height: 100%;
              }
            }
          }
          .right {
            width: 840px;
            height: 67px;
            float: right;
            ul {
              width: 840px;
              height: 67px;
              list-style: none;
              display: flex;
              font-size: 14px;
              line-height: 67px;
              text-align: center;
              margin-right: 282px;

              li.router-link-active {
                width: 140px;
                height: 50px;
                background: #ff8229;
                border-radius: 25px;
                cursor: pointer;
                color: white;
              }
              .isActive {
                width: 140px;
                height: 50px;
                background: #ff8229;
                border-radius: 25px;
                cursor: pointer;
                color: white;
              }
              > li {
                width: 140px;
                height: 50px;
                color: black;
                font-size: 18px;
                line-height: 50px;
                text-align: center;
                margin-top: 8px;

                a {
                  width: 27px;
                  height: 14px;
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #333333;
                  line-height: 30px;
                }
              }

              li:hover {
                width: 140px;
                height: 50px;
                background: #ff8229;
                border-radius: 25px;
                cursor: pointer;
                color: white;
              }
            }
          }
        }
      }
    }
    ul {
      list-style: none;
    }
    .bottom1 {
      width: 99.8%;
      min-width: 1427px;
      height: 387px;
      margin: 0 auto;
      background: #ffffff;
      border: 1px solid #e6e6e6;
      .bottomCenter {
        width: 1427px;

        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .left {
          width: 70%;
          height: 100%;
          float: left;
          /* float: left; */
          .img {
            width: 109px;
            height: 127px;
            margin-bottom: 115px;
            margin-top: 105px;
            float: left;
            > img {
              width: 100%;
              height: 100%;
              background: #ffffff;
            }
          }
          .ul {
            width: 100%;
            height: 100%;
          }
          .ul1 {
            width: 10%;

            margin-top: 103px;
            margin-left: 13.59%;
            float: left;
            li > a {
              width: 100%;
              height: 12px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 30px;
              margin-bottom: 16px;
              cursor: pointer;
            }
            .LiBig {
              width: 100%;
              height: 14px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 600;
              color: #1a1a1a;
              line-height: 30px;
              margin-bottom: 29px;
            }
          }
          .ul2 {
            width: 10%;

            margin-top: 103px;
            margin-left: 5.9%;
            float: left;
            li > a {
              width: 100%;
              height: 12px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 30px;
              margin-bottom: 16px;
              cursor: pointer;
            }
            .LiBig {
              width: 100%;
              height: 14px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 600;
              color: #1a1a1a;
              line-height: 30px;
              margin-bottom: 29px;
            }
          }
          .ul3 {
            width: 10%;
            margin-top: 103px;
            margin-left: 5.94%;
            float: left;
            li > a {
              width: 100%;
              height: 12px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 30px;
              margin-bottom: 16px;
              cursor: pointer;
            }
            .LiBig {
              width: 100%;
              height: 14px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 600;
              color: #1a1a1a;
              line-height: 30px;
              margin-bottom: 29px;
            }
          }
          .ul4 {
            width: 25%;
            margin-top: 103px;
            margin-left: 5.94%;
            float: left;
            li {
              width: 100%;
              height: 13px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 22px;
              margin-bottom: 16px;
              a {
                cursor: pointer;
              }
            }
            .LiBig {
              width: 100%;
              height: 14px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 600;
              color: #1a1a1a;
              line-height: 30px;
              margin-bottom: 28px;
            }
          }
        }

        .right {
          padding-top: 104px;
          margin-right: 0;
          .Rt {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .Rt1 {
              width: 77px;
              height: 104px;
              img {
                width: 77px;
                height: 77px;
              }
            }
            p {
              width: 80px;
              height: 14px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #1a1a1a;
              line-height: 30px;
              text-align: center;
            }
            .Rt2 {
              /* margin-left: 38px; */
              width: 77px;
              height: 104px;
              img {
                width: 77px;
                height: 77px;
              }
            }
          }
          .Rb {
            margin-top: 25px;
            width: 192px;
            display: flex;
            justify-content: space-between;
            a {
              width: 36px;
              height: 36px;
              img {
                width: 36px;
                height: 36px;
              }
            }
          }
        }
      }
      .bottomB {
        width: 100%;
        height: 40px;
        background: #ff8229;
        text-align: center;
        line-height: 40px;
        color: white;

        a {
          margin-left: 0px;
          width: 108px;
          height: 13px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 30px;
          a {
            height: 13px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 30px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1020px) {
  .xuanfu {
    display: none;
  }
  .NavCenter {
    display: none;
  }
  .Nav1 {
    display: none;
  }
  ul,
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .phone-nav {
    padding-left: 25px;
    padding-right: 25px;
    box-sizing: border-box;
    width: 100%;
    height: 100px;
    background: #fcf9f5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .phone-logo {
      height: 56px;
      img {
        height: 100%;
      }
    }
    .phone-nav-link {
      width: 100%;
      li {
        width: 100%;
        padding-left: 40px;
        box-sizing: border-box;
        height: 80px;
        border-bottom: 1px solid #e6e6e6;
        line-height: 80px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999999;
      }
      li:hover {
        color: #ff8229;
      }
    }
  }
  .bottom1 {
    width: 100%;
    // padding-top:20px;
    // height:387px;
    background: #fff;
    .bottomCenter {
      width: 100%;
      height: 240px;
      padding-left: 20px;
      padding-right: 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .left {
        .img {
          width: 40%;
          > img {
            width: 100%;
          }
        }
        ul,
        li {
          list-style: none;
        }
        .ul1 {
          display: none;
        }
        .ul2 {
          display: none;
        }
        .ul3 {
          display: none;
        }
        .ul4 {
          display: none;
        }
      }
      .right {
        .Rt {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          .Rt1 {
            width: 77px;
            height: 104px;
            img {
              width: 77px;
              height: 77px;
            }
          }
          p {
            width: 80px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1a1a1a;
            line-height: 14px;
            text-align: center;
          }
          .Rt2 {
            margin-left: 38px;
            width: 77px;
            height: 104px;
            img {
              width: 77px;
              height: 77px;
            }
          }
        }
        .Rb {
          margin-top: 25px;
          width: 192px;
          display: flex;
          justify-content: space-between;
          a {
            width: 36px;
            height: 36px;
            img {
              width: 36px;
              height: 36px;
            }
          }
        }
      }
    }

    .bottomB {
      width: 100%;
      height: 40px;
      background: #ff8229;
      text-align: center;
      line-height: 40px;
      color: white;
      a {
        text-decoration: none;
      }
      a {
        margin-left: 0px;
        // width: 108px;
        height: 13px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
        a {
          height: 13px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
